module.exports = __webpack_public_path__ + "img/previewImg1.ded5c9d3.png";